import { InputGroupComponentConfig, IconType } from '@rappider/rappider-components/utils';

export const searchBarConfig: InputGroupComponentConfig = {
  textbox: {
    placeholder: 'Search in comments'
  },
  suffixIcon: {
    name: 'fas fa-search',
    type: IconType.FontAwesome
  }
};
